import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'

import { withAuthorizer, withWorkspace } from '../../containers/high-order-components'
import { WorkspacePropType } from '../../containers/high-order-components/with-workspace'
import RouteMapService from '../../services/route-map'

class RedirectRoute extends Component {

    static propTypes = {
        authorizer: PropTypes.object.isRequired,
        navItem: PropTypes.object.isRequired,
        workspace: WorkspacePropType.isRequired
    }

    constructor(props) {
        super(props)
    }

    render() {
        const { authorizer, navItem, workspace, ...otherProps } = this.props
        const route = RouteMapService.resolveRoute(navItem, authorizer, workspace)

        return <Redirect {...otherProps} to={route} />
    }

}

export default withAuthorizer(withWorkspace(RedirectRoute))


// WEBPACK FOOTER //
// src/components/auth/redirect-route.js